import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const LoginButton = () => {
  const navigate = useNavigate();
  
  return (
    <Button 
      variant="outline" 
      onClick={() => navigate("/auth")} 
      size="icon"
      title="تسجيل الدخول"
    >
      <LogIn className="w-4 h-4" />
    </Button>
  );
};